import React from 'react';
import { connect } from 'react-redux';
import {
    fetchHeaderFooterComponent,
} from '../header-footer/header-footer-actions';

import './disclaimer-list.less';

const DEFAULT_DISCLAIMER = [];
const EMPTY_OBJ = {};

class DisclaimerList extends React.PureComponent {
    componentDidMount() {
        const { fetchDisclaimer, sections } = this.props;

        // TODO: need a better flag for if the data needs to be fetched
        if (!sections || sections.length === 0) {
            fetchDisclaimer();
        }
    }

    render() {
        const { sections = DEFAULT_DISCLAIMER, featuresDisclaimers, techSpecDisclamers } = this.props;

        return (<div className={"disclaimer-content"}>
            {sections.map((el, idx) => (
                <p key={idx}>{el}</p>
            ))}
            {
                featuresDisclaimers ? <>
                    <h4>Features</h4>
                    {featuresDisclaimers.map((el, idx) => (
                        el ? <p key={idx}>{el}</p> : null
                    ))}
                </> : null
            }
            {
                techSpecDisclamers ? <>
                    <h4>Technical Details</h4>
                    {techSpecDisclamers.map((el, idx) => (
                        el ? <p key={idx}>{el}</p> : null
                    ))}
                </> : null
            }
        </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    const { disclaimer } = state.headerFooter || EMPTY_OBJ;
    const { components = EMPTY_OBJ } = state.slugInfo || EMPTY_OBJ;
    const { pdpFeatures = EMPTY_OBJ, product = EMPTY_OBJ } = components;
    const { disclaimers: featuresDisclaimers } = pdpFeatures;
    const { disclaimers: techSpecDisclamers } = product;

    return {
        sections: disclaimer.sections,
        featuresDisclaimers,
        techSpecDisclamers
    };
}

const mapDispatchToProps = (dispatch) => ({
    fetchDisclaimer: () => dispatch(fetchHeaderFooterComponent(['disclaimer'])),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisclaimerList);